import {
  AggregateDataverseChartDataSource,
  AggregateType,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.PieChart.PieChartMainDemo';

export function PieChartMainSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'opportunityratingcode',
        aggregateColumn: 'estimatedvalue',
        aggregate: AggregateType.Sum,
      }),
    [],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Pie}
        title={t(`${STRINGS_BASE}.chart-title`)}
        yAxisPrefix="$"
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.label} — ${lastClick.value.toLocaleString()}
        </p>
      )}
    </>
  );
}
